import { Col, Stack, Body, IconButton } from '@workramp/ui';
import styled from 'styled-components';

export const ResultTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => `${theme.spacing(2)}px`};
`;

export const TitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: ${({ theme }) => `${theme.spacing(4)}px`};
`;

export const ResultBodyStack = styled(Stack)`
  padding-left: ${({ theme }) => `${theme.spacing(6)}px`};
`;

export const InfoWrapper = styled(Col)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => `${theme.spacing(2)}px`};
  color: ${({ theme }) => theme.colors.on[600]};
`;

export const FooterWrapper = styled(Body)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: ${({ theme }) => `${theme.spacing(3)}px`};
`;

export const ActionIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => `${theme.spacing(2)}px`};
  color: ${({ theme }) => theme.colors.on[600]};
`;

type ActionIconProps = {
  iconColor: string;
};

export const ActionIcon = styled(IconButton)<ActionIconProps>`
  background-color: transparent;
  border-color: transparent;
  color: ${(props) => props.iconColor};

  &:hover {
    background-color: transparent;
    border-color: transparent;
  }
`;
